<script setup lang="ts">
import type { Content } from '@prismicio/client'

defineProps(getSliceComponentProps<Content.OpenSolicitationCtaSlice>())
</script>

<template>
  <section
    :data-slice-type="slice.slice_type"
    :data-slice-variation="slice.variation"
    class="pa-open-cta"
  >
    <div class="pa-container">
      <div class="pa-open-cta__card">
        <div class="pa-open-cta__content">
          <span v-if="slice.primary.label" class="pa-open-cta__label">
            {{ slice.primary.label }}
          </span>
          <div class="pa-open-cta__heading">
            <PrismicRichText :field="slice.primary.heading" />
          </div>
          <div class="pa-open-cta__description">
            <PrismicRichText :field="slice.primary.description" />
          </div>
          <div v-if="slice.primary.buttons?.length" class="pa-open-cta__buttons">
            <PrismicLink
              v-for="(button, index) in slice.primary.buttons"
              :key="index"
              :field="button"
              class="pa-open-cta__btn"
              :class="
                button.variant === 'Secondary'
                  ? 'pa-open-cta__btn--secondary'
                  : 'pa-open-cta__btn--primary'
              "
            >
              {{ button.text }}
              <span v-if="button.variant !== 'Secondary'" aria-hidden="true">&rarr;</span>
            </PrismicLink>
          </div>
        </div>

        <div class="pa-open-cta__image">
          <PrismicImage
            v-if="slice.primary.backgroundImage?.url"
            :field="slice.primary.backgroundImage"
            :widths="[600, 900, 1200]"
            sizes="(min-width: 768px) 50vw, 100vw"
            :imgix-params="{ fit: 'crop', auto: 'format,compress' }"
          />
        </div>
      </div>
    </div>
  </section>
</template>
